import { useDispatch } from "react-redux";
import {useLazyGetPrivacyPolicyQuery} from "../../../Store/Builder/techsbook.api";
import { setLoader, setPrivacy } from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";

const useGetPrivacyPolicyApi = () => {
  const dispatch = useDispatch();
  const [getPrivacyPolicy] = useLazyGetPrivacyPolicyQuery();

  const get = () => {
    dispatch(setLoader(true));
    getPrivacyPolicy()
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        dispatch(setPrivacy(res));
      })
      .catch((err) => {
        dispatch(setLoader(false));
        if(err?.status === 401) {
          localStorage.removeItem('techsbook_customer_portal_token')
        }
        showToast(err?.data?.message ?? "Error account", "error");
      });
  };

  return {
    get,
  };
};

export default useGetPrivacyPolicyApi;
